// extracted by mini-css-extract-plugin
export default {"section":"Sz-z","inSectionButton":"Tz-z","addressCard":"Uz-z","disabled":"Vz-z","cautionBox":"Wz-z","failureBox":"Xz-z","fade-out":"Yz-z","successBox":"Zz-z"};